import { Trans } from "@/plugins/Translation";
import moment from "moment";
import psl from "psl"

export default class GenericClass {

    static mobileMaxWidth() { return 600; }
    static distribution() { return "Distribution"; }
    static transport() { return "Transport"; }
    static airocean() { return "Air & Ocean"; }
    static logistics() { return "Logistics"; }
    static specialservices() { return "Special Services"; }

    static getColor(divisionId) {
        if (divisionId == 1) return "#D94D00";

        if (divisionId == 2) return "#00489B";

        if (divisionId == 3) return "#008EE9";

        if (divisionId == 4) return "#279A47";

        if (divisionId == 5) return "#E7B444";
    }

    static getProfileDivisions() {
        return [
            {
                title: Trans.i18n.t("Divisions.Distribution"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-14",
                color: "#D94D00",
                description: ""
            },
            {
                title: Trans.i18n.t("Divisions.Transport"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-11",
                color: "#00489B",
                description: ""
            },
            {
                title: Trans.i18n.t("Divisions.AirOcean"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-12",
                color: "#008EE9",
                description: ""
            },
            {
                title: Trans.i18n.t("Divisions.Logistics"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-13",
                color: "#279A47",
                description: ""
            },
            {
                title: Trans.i18n.t("Divisions.SpecialServices"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-15",
                color: "#E7B444",
                description: ""
            },
        ];
    }

    static getQuotationsDivisions() {
        return [
            {
                title: Trans.i18n.t("Divisions.Distribution"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-14",
                color: "#D94D00",
                opacity: 0.5,
            },
            {
                title: Trans.i18n.t("Divisions.Transport"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-11",
                color: "#00489B",
                opacity: 0.5,
            },
            {
                title: Trans.i18n.t("Divisions.AirOcean"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-12",
                color: "#008EE9",
                opacity: 0.5,
            },
            {
                title: Trans.i18n.t("Divisions.Logistics"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-13",
                color: "#279A47",
                opacity: 0.5,
            },
            {
                title: Trans.i18n.t("Divisions.SpecialServices"),
                img_name: "FERCAM_ICONE_DIVISIONALI_RGB-15",
                color: "#E7B444",
                opacity: 0.5,
            },
        ];
    }

    static GetCurrentDomain() {
        var hostName = window.location.hostname;
        return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
    }

    static ChangeAppUrlDomain(appUrl) {

        var hostName = window.location.hostname;
                
        let parsed = psl.parse(hostName);        
        var siteName = parsed.subdomain ? appUrl.split(".")[0] : "";
        var mySiteName = parsed.subdomain ? parsed.subdomain.split(".")[0] : "";
        var fullDomain = parsed.subdomain ? parsed.subdomain.replace(mySiteName, "") + "." + parsed.domain : "";
        // console.log("asd", fullDomain);
        return siteName + fullDomain;        
    }

    static GetSSOUrl() {
        var hostName = window.location.hostname;
        let parsed = psl.parse(hostName);
        // console.log("parsed", parsed);
        var siteName = parsed.subdomain ? parsed.subdomain.split(".")[0] : "";
        var fullDomain = parsed.subdomain ? parsed.subdomain.replace(siteName, "") + "." + parsed.domain : "";

        var sso_url = process.env.VUE_APP_SSO + fullDomain;

        // console.log("sso_url", sso_url, parsed, fullDomain);
        return sso_url;
    }

    static TruncateString(item, truncate) {
        if (
            item.length >
            process.env.VUE_APP_MAX_COMPRESSION_TRUNCATE_VALUE &&
            truncate
        ) {
            return item.substring(
                0,
                process.env.VUE_APP_MAX_COMPRESSION_TRUNCATE_VALUE
            ) + "...";
        } else return item;
    }

    static TruncateRoleString(item, truncate) {
        if (
            item.length >
            11 &&
            truncate
        ) {
            return item.substring(
                0,
                11
            ) + "...";
        } else return item;
    }


    static GetDivisionDB() {
        return [
            { id: "1", name: "All", description: "Tutte" },
            { id: "3", name: "Distribution", description: "Distribution" },
            { id: "4", name: "AirOcean", description: "Air & Ocean" },
            { id: "5", name: "Logistics", description: "Logistics" },
            { id: "6", name: "Transport", description: "Transport" },
            { id: "7", name: "SpecialServices", description: "Special Services" }
        ]
    }

    static isValidDate(datetime) {
        if (!datetime || (datetime && datetime.length < 19)) {
            return false;
        }

        var parsed = moment(datetime, moment.ISO_8601);
        //console.log("datetime", datetime, parsed.isValid());
        return parsed.format() != "Invalid date";
    }

    static formatDate(datetime, isMobile) {
        if (this.isValidDate(datetime)) {
            if (!isMobile)
                return moment(datetime).format("DD/MM/YYYY HH:mm:ss");
            else return moment(datetime).format("DD/MM/YYYY");
        } else return "";
    }
}